import { useQuery } from '@tanstack/react-query';

import { CONNECTED_APPS_QUERY_KEYS, getConnectedApps } from '../api';

export const useConnectedApps = () =>
  useQuery({
    queryKey: CONNECTED_APPS_QUERY_KEYS.list,
    queryFn: getConnectedApps,
  });
